/* global mockup:true */
/* eslint no-console: 0, no-unused-vars: 0, no-undef: 0, no-unused-expressions: 0 */
import Vue from 'vue'
import Sentry from '~/util/sentry'
import Router from 'vue-router'
import VueMoment from 'vue-moment'
import apolloClient from '~/util/apolloClient'
import datadog from '~/util/datadog.js'
import vuetify from '~/util/vuetify.js'
import axios from '~/util/axios'
import { VueMaskDirective } from 'v-mask'
import Snackbard from 'snackbard'
import Snui from '~/components/snui/v2'
import printJS from 'print-js'

// Components
import App from '~/components/portals/closing/App.vue'

// Style
import 'mdi/css/materialdesignicons.min.css'

if (['development', 'staging'].includes(process.env.RAILS_ENV)) {
  Vue.config.devtools = true
}

const { VueApollo, provider } = apolloClient()
datadog({ packName: 'closingPortal' })

Vue.use(Router)
Vue.use(VueMoment)
Vue.use(VueApollo)
Vue.use(Snackbard)
Vue.use(Snui)

Vue.directive('mask', VueMaskDirective)

const routes = [
  {
    path: '/portal/closing/files/:loanGuid',
    name: 'File',
    component: () =>
      import('~/components/portals/closing/file/closingPortalFile.vue')
  },
  {
    path: '/portal/closing/files',
    name: 'Files',
    component: () =>
      import('~/components/portals/closing/Files/Files.vue')
  },
  {
    path: '/portal/closing/login',
    name: 'Login',
    component: () =>
      import('~/components/portals/closing/login.vue')
  },
  { path: '*', redirect: '/portal/closing/files' }
]

const router = new Router({
  mode: 'history',
  routes: routes
})

router.beforeEach(function (_to, _from, next) {
  window.scrollTo(0, 0)
  next()
})

const formatDateTime = (value) => {
  if (!value) { return '' }
  return Vue.prototype.$moment(value).format('MMM D, YYYY, h:mmA').toString()
}
const formatDate = (value) => {
  if (!value) { return '' }
  return Vue.prototype.$moment(value).format('MMM D, YYYY').toString()
}

const formatTime = (value) => {
  if (!value) { return '' }
  return Vue.prototype.$moment(value).format('h:mm A').toString()
}

const downloadFile = async (url, downloadName) => {
  await fetch(url)
    .then(resp => resp.arrayBuffer())
    .then(resp => {
      const file = new Blob([resp], { type: 'application/pdf' })
      const link = document.createElement('a')
      link.download = downloadName
      link.href = URL.createObjectURL(file)
      link.target = '_blank'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      // Remove the file from memory after a little time has passed
      setTimeout(() => URL.revokeObjectURL(link.href), 5000)
    })
}

const openFile = (url) => {
  window.open(url, '_blank')
}

const printFile = (url) => {
  return new Promise((resolve, reject) => {
    if (navigator.vendor.toLowerCase().includes('apple')) {
      var newWin = window.open(url)
      if (newWin) {
        newWin.onload = resolve
        newWin.onerror = reject
      } else {
        reject(new Error('Unable to open new window'))
      }
    } else {
      printJS({
        printable: url,
        type: 'pdf',
        showModal: true,
        onLoadingEnd: resolve,
        onError: reject
      })
    }
  })
}

Vue.filter('formatDateTime', formatDateTime)
Vue.filter('formatDate', formatDate)
Vue.filter('formatTime', formatTime)

Vue.mixin({
  methods: {
    formatDateTime: formatDateTime,
    formatDate: formatDate,
    formatTime: formatTime,
    downloadFile: downloadFile,
    openFile: openFile,
    printFile: printFile
  }
})

Vue.prototype.$sentry = Sentry([{ key: 'pack', value: 'Closing Portal' }])
Vue.prototype.$axios = axios

new Vue({
  router,
  apolloProvider: provider,
  render: h => h(App),
  vuetify
}).$mount('#app-container')
